import {
  Avatar,
  Box,
  Heading,
  HStack,
  StackDivider,
  VStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Button,
} from "@chakra-ui/react";
import { BellSimple, Power } from "phosphor-react";
import React from "react";
import { COLORS } from "../../Helper/Colors";
import noimg from "../../Assets/profile_placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton } from "../../Components/Common/UI";
import Api from "../../Helper/ApiHandler";
import { logout } from "../../Redux/Auth/Actions";
import { CustomToast } from "../../Helper/Toast";

const Background = ({ children, heading, showBack = false }) => {
  const userData = useSelector((state) => state.loginData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const api = new Api();

  const logoutHandler = async () => {
    try {
      const response = await api.delete("auth/logout");
      if (response.status === 1) {
        dispatch(logout());
        return navigate("/logout", {
          replace: true,
          state: { loggedOut: true },
        });
      } else {
        CustomToast("error", "Something went wrong!");
      }
    } catch (error) {
      CustomToast("error", error.message);
    }
  };

  return (
    <Box
      height={"100%"}
      overflow={"hidden"}
      backgroundColor={COLORS.brandLight}
      padding={4}
      borderRadius={"20px"}
    >
      <VStack
        divider={<StackDivider borderColor="gray.200" />}
        height={"100%"}
        spacing={4}
        align="stretch"
        position={"relative"}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <HStack spacing={0} alignItems={"center"}>
            {showBack && <BackButton onClick={() => navigate(-1)} />}
            <Heading
              as="h4"
              fontSize={"25px"}
              fontWeight={700}
              fontFamily={"inherit"}
              color={"text.500"}
              textTransform={"capitalize"}
            >
              {heading}
            </Heading>
          </HStack>
          <HStack spacing={4} alignItems={"center"}>
            <Popover
              autoFocus={false}
              matchWidth
              arrowShadowColor={COLORS.menuBoxShadow}
              arrowSize={12}
              offset={[0, 10]}
              closeOnBlur={true}
              closeOnEsc={true}
              trigger="hover"
            >
              <PopoverTrigger>
                <img
                  width={"60px"}
                  height={"60px"}
                  name={
                    userData?.firstName + " " + userData?.lastName || "John doe"
                  }
                  src={userData?.profilePhoto || noimg}
                />
              </PopoverTrigger>
              <PopoverContent
                width={"130px"}
                marginRight={"1rem"}
                border={"none"}
                boxShadow={COLORS.menuBoxShadow}
              >
                <PopoverArrow
                  boxShadow={COLORS.menuBoxShadow}
                  left={"8px !important"}
                />
                <PopoverBody padding={"5px !important"}>
                  <Button
                    variant={"ghost"}
                    colorScheme="white"
                    textColor={COLORS.red}
                    width={"100%"}
                    fontSize={"18px"}
                    fontWeight={400}
                    borderColor={"none"}
                    onClick={logoutHandler}
                    leftIcon={<Power size={22} color={COLORS.red} />}
                    _focus={{}}
                    _active={{}}
                  >
                    Logout
                  </Button>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </HStack>
        </Box>
        {children}
      </VStack>
    </Box>
  );
};

export default Background;
